'use client';

import ImageWithLoader from '@/components/common/images/ImageWithLoader';
import { teamMembers } from '@/lib/constants/teamMembers';

export default function OurTeam() {
  return (
    <div className="mx-auto px-4 sm:px-6 lg:px-16">
      <div className="text-center mb-16">
        <h1 className="text-4xl md:text-5xl font-bold text-blue-950 mb-6">Nuestro Equipo</h1>
        <p className="text-lg text-blue-950 w-full lg:w-3/5 mx-auto leading-relaxed">
          Conoce a los profesionales que hacen posible nuestro éxito. Un equipo comprometido con la
          excelencia y la innovación en cada proyecto que emprendemos.
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-8 mb-16 mx-auto max-w-[1440px] xl:px-16">
        {teamMembers.map((member) => (
          <div
            key={member.id}
            className="w-72 h-80 pb-4 bg-white rounded-2xl outline-1 outline-offset-[-1px] outline-gray-200 inline-flex flex-col justify-center items-start gap-2 hover:scale-105 transition-all duration-300"
          >
            <div className="flex justify-center items-center w-72 h-60 overflow-hidden rounded-t-2xl">
              <ImageWithLoader
                src={member.image}
                alt={member.name}
                width={500}
                height={500}
                unoptimized
                className="w-full h-full object-contain rounded-t-2xl"
              />
            </div>
            <div className="px-4 flex flex-col justify-center items-start gap-6 w-full h-26">
              <div className=" flex flex-col justify-start items-start gap-2">
                <div className=" flex flex-col justify-start items-start gap-1">
                  <div className=" justify-start text-gray-900 text-lg font-semibold leading-7">
                    {member.name}
                  </div>
                  <div className=" justify-start text-slate-800 text-base font-normal leading-normal">
                    {member.position}
                  </div>
                  <div className=" justify-start text-slate-600 text-sm font-normal leading-tight">
                    {member.department}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
